const urls = {
  briefs: '/model/briefs',
  products: '/dictionary/products',
  channels: '/dictionary/channels',
  companies: '/dictionary/companies',
  pools: '/dictionary/pool_companies',
  kpis: '/dictionary/kpis',
  medias: '/dictionary/medias',
  taskTypes: '/dictionary/task_types',
  modelTypes: '/dictionary/model_types',
  tasksStatuses: '/dictionary/task_statuses',
  criterions: '/model/criterions',
  efficiencyMetrics: '/dictionary/efficiency_metrics',
  metrics: '/dictionary/metrics',
  mediaObjects: '/media_objects',
  stageTypes: '/dictionary/stage_types?order[order]=ASC&isDefault=true',
  managers: '/managers',
  briefTaskChannels: '/model/brief_task_channels',
  briefTaskKpis: '/model/brief_kpi_tasks',
  briefChannels: '/model/brief_channels',
  briefTaskChannelsData: '/model/brief_task_channel_datas',
  briefTaskKpiData: '/model/brief_kpi_task_datas',
  briefTasks: '/model/brief_tasks',
  briefStages: '/model/brief_stages',
  briefTasksData: '/model/brief_task_datas',
  models: '/model/models',
  modelsFileTypes: '/dictionary/model_file_types',
  briefManagers: '/model/brief_managers',
  commentaries: '/commentary/commentaries',
  engines: '/engine/engines',
  engineChannels: '/engine/channels',
  enginesFile: '/engine/engines/file',
  engineFactors: '/engine/factors',
  periods: '/engine/periods',
  dataTotals: '/engine/data_totals',
  dataChannels: '/engine/data_channels',
  stageStatuses: '/dictionary/stage_statuses',
  validationResults: '/dictionary/model_validation_results',
  briefGroupTypes: '/dictionary/brief_group_types',
  briefPositions: '/dictionary/brief_positions',
  reports: '/engine/reports',
};

export default urls
